import { useGalaxyAdminCategories } from "../../../hooks/useGalaxyAdminLists";
import CategoryHeaderImageSettings from "../CategoryHeaderImageSettings";
import { GalaxyCategoryRows, GalaxyCategoryToolbar } from "./CategoryDragTable";
import withGalaxyCategoryOrder from "./CategoryDragTable";
import React, { useEffect, useState } from "react";
import editData from "../../../assets/edit-1.png";
import deleteData from "../../../assets/delete-1.png";
import AddCategory from "./addCategory/AddCategory";
import EditCategory from "./editCategory/EditCategory";
import DeleteCategory from "./deleteCategory/DeleteCategory";
import ReactPaginate from "react-paginate"
import {
  useGetCategoryQuery,
  useDeleteCategoryMutation,
} from "../../../Services/CategoryApi";
import { GetUrl } from "../../../config/GetUrl";
import { toast } from "react-toastify";
import LoadingAction from "../../../components/Loader";

const Categories = () => {

  const [deleteCategory] = useDeleteCategoryMutation();
  const [show, setShow] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [categories, setCategories] = useState([""]);
  const [categoryId, setCategoryId] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [paginated, setPaginated] = useState([])
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [search, setSearch] = useState('')
  const { data: retrieveCategory, refetch, isLoading } = useGalaxyAdminCategories({ search, limit: pageSize, page: page + 1 });
  useEffect(() => {
    console.log({ retrieveCategory })
    setCategories(retrieveCategory?.data?.categories);
    setTotalPageCount(retrieveCategory?.data?.pagination?.totalPages)
  }, [retrieveCategory]);
  const handleAddCategory = (newCategory) => {
    setCategories([...categories, newCategory]);
  };
  const AddCategoryHandler = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setShowEdit(false);
    setShowDeleteModal(false);
  };
  const editShowHandler = (e, id) => {
    e.preventDefault();
    setShowEdit(true);
    setCategoryId(id);
  };
  const deleteShowHandler = (e, id) => {
    e.preventDefault();
    setShowDeleteModal(true);
    setCategoryId(id);
  };

  const handleDeleteCategory = () => {
    setShowLoader(true)
    deleteCategory(categoryId)
      .unwrap()
      .then((res) => {
        toast.success(res?.message);
        setShowLoader(false)
        setCategories(
          categories.filter((category) => category.id !== categoryId)
        );
        refetch();
      })
      .catch((err) => {
        setShowLoader(false)
        toast.error(err?.data?.message);
      });
  };
  const handlePageClick = (event) => {
    setPage(event.selected)

  };
  const refetchData = () => {
    refetch()
  }

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      refetch();
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [search, page]);




  return (
    <>
      <main id="main" className="main mt-0 h-100 min-vh-80">
      <div className="mb-4">
        <CategoryHeaderImageSettings />
      </div>
    


        <div class="pagetitle">
          <div className="d-flex justify-content-between align-items-center mb-3 mobile-block">
            <div className="d-flex gap-4 mobile-block">

              <div className="div">
                <h1>Manage Categories</h1>
                <nav>
                  <ol class="breadcrumb mb-0">
                    <li class="breadcrumb-item"><a href="">Home</a></li>
                    <li class="breadcrumb-item active">Manage Categories</li>
                  </ol>
                </nav>
              </div>


              <div class="search-bar mt-1">
                <form class="d-flex" role="search">
                  <div class="border-rounded-15 border-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control border-0 bg-none"
                        placeholder="Search..."
                      //onChange={handleSearch}
                      />
                      <span className="input-group-text bg-none border-0">
                        <i className="b- bi-search"></i>
                      </span>
                    </div>
                  </div>
                </form>
              </div>
            </div>



            <div class="">
              <button className="btn btn-main me-2" onClick={AddCategoryHandler}><i className="bi bi-plus-lg me-2"></i>Add Category</button>
            </div>
          </div>
        </div>




        <AddCategory
          show={show}
          handleClose={handleClose}
          onCategoryAdded={handleAddCategory}
        />
        {showEdit && (
          <EditCategory
            showEdit={showEdit}
            handleClose={() => setShowEdit(false)}
            categoryId={categoryId} // Pass categoryId to EditCategory component
            onCategoryAdded={handleAddCategory}
            refetchData={refetchData}
          />
        )}
        {showDeleteModal && (
          <DeleteCategory
            showDeleteModal={showDeleteModal}
            handleClose={handleClose}
            handleDelete={handleDeleteCategory} // Pass handleDeleteCategory function
          />
        )}

        <div className="container-fluid mt-2 pt-2">
          <div className="row">
            <div className="col-md-12 px-0">
              {showLoader && <LoadingAction />}
              <div className="clearfix mb-4 mt-2">
                <div className="float-start">
                  <h6 className="text-color fw-bolder mb-0">Categories List</h6>
                  {/* <div className="search-bar mt-1">
                    <form className="d-flex" role="search">
                      <div className="border-rounded-15">
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control border-0 bg-none"
                            placeholder="Search..."
                          value={search}
                                          onChange={(e) => setSearch(e.target.value)}
                          />
                          <span className="input-group-text bg-none border-0">
                            <i className="b- bi-search"></i>
                          </span>
                        </div>
                      </div>
                    </form>
                  </div> */}
                </div>
                {/* <div className="float-end">
                  <button
                    className="btn btn-main me-2"
                    onClick={AddCategoryHandler}
                  >
                    <i className="bi bi-plus-lg me-2"></i>Add Category
                  </button>
                </div> */}
              </div>

              <div className="card border-0 table-card">
                <div className="card-body">
                  <div className="table-responsive">
                    <><GalaxyCategoryToolbar /><table className="table table-striped mb-0 align-middle common-table ">
                      <thead>
                        <tr><th scope="col" style={{width:48}}>Move</th>
                          <th scope="col">S no.</th>
                          <th scope="col">Category Name</th>
                          <th scope="col">Image</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {categories && <GalaxyCategoryRows rows={categories || []} renderRow={(category, index) => (
                          <tr key={index}>
                            <th scope="row">{index + 1}</th>
                            <td>{category?.name}</td>
                            <td>
                              <img
                                src={category?.image}
                                alt="Profile"
                                width="40"
                                height="40"
                                className="rounded-circle"
                              />
                            </td>
                            <td>
                            <button
                                className="btn btn-edit me-2 action-wh"
                                onClick={(e) =>
                                  editShowHandler(e, category?._id)
                                }
                              >
                                <img
                                  src={editData}
                                  alt="image"
                                  className="img-fluid action-image"
                                />
                              </button>
                              { GetUrl.REACT_APP_MERCHANDISE_ID != category?._id && <button
                                className="btn btn-delete  me-2 action-wh"
                                onClick={(e) =>
                                  deleteShowHandler(e, category?._id)
                                }
                              >
                                <img
                                  src={deleteData}
                                  alt="image"
                                  className="img-fluid action-image"
                                />
                              </button>}
                            </td>
                          </tr>
                        )} />}

                      </tbody>
                    </table></>
                    {categories?.length == 0 && <span className="no-data my-4 fw-bold"><p>No Data Found</p></span>}
                  </div>
                  {categories?.length > 0 &&
                    <ReactPaginate
                      breakLabel="..."
                      breakClassName={'break'}
                      nextLabel=" >"
                      containerClassName={"pagination"}
                      activeClassName={"active"}
                      onPageChange={handlePageClick}
                      forcePage={page}
                      pageRangeDisplayed={5}
                      marginPagesDisplayed={1}
                      pageCount={totalPageCount}
                      previousLabel="< "
                      renderOnZeroPageCount={null}
                    />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>

      </main>

    </>
  );
};

export default withGalaxyCategoryOrder(Categories);
